<template>
  <div class="matrix-container">
    <div :class="[isValided ? 'error-border' : 'common-container']">
      <div class="quesName">
        <span v-show="isQuestionNum">{{ index }}.</span>
        <span
          class="question-name-text"
          v-html="formattedQuestionName"
          @click="handleHtmlClick"
        ></span>
        <!-- <span class="question-name-text">{{ MatrixQuestionOption.name }}</span> -->
        <span class="starRed" v-if="MatrixQuestionOption.isMust == 1">*</span>
        <span class="chexMinMax">
          <span
            v-if="
              MatrixQuestionOption.minValue && MatrixQuestionOption.minValue > 0
            "
            >最小值{{ MatrixQuestionOption.minValue }}</span
          >
          <span
            v-if="
              MatrixQuestionOption.maxValue && MatrixQuestionOption.maxValue > 0
            "
            >最大值{{ MatrixQuestionOption.maxValue }}</span
          >
        </span>
      </div>
      <div class="questionContainer">
        <el-table :data="MatrixQuestionOption.rowType" style="width: 100%">
          <el-table-column>
            <template slot-scope="scope">{{ scope.row.name }}</template>
          </el-table-column>
          <el-table-column
            :key="opt.id"
            v-for="opt in MatrixQuestionOption.columnType"
            :label="opt.name"
          >
            <template slot-scope="scope">
              <el-input
                v-model="opt.rowType[scope.$index].value"
                v-if="MatrixQuestionOption.inputType === 'number'"
                type="number"
                @mousewheel.native.prevent
                :disabled="isAnswered"
                @input="handleInputChange(opt, scope.$index)"
              ></el-input>
              <el-input
                v-model="opt.rowType[scope.$index].value"
                v-if="MatrixQuestionOption.inputType === 'row'"
                @input="handleInputChange(opt, scope.$index)"
                :disabled="isAnswered"
              ></el-input>
              <el-checkbox
                v-model="opt.checkedValue"
                v-if="MatrixQuestionOption.inputType === 'checkbox'"
                :label="scope.row.id"
                @change="handleCheckboxChange(scope, opt)"
                :disabled="isAnswered"
              >
                <span></span>
              </el-checkbox>
              <el-radio
                v-model="opt.value"
                @change="handleRadioChange(scope, opt)"
                v-if="MatrixQuestionOption.inputType === 'radio'"
                :label="scope.row.id"
                :disabled="isAnswered"
              >
                <span></span>
              </el-radio>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 图片预览 -->
    <van-image-preview
      v-model="showPreview"
      :images="previewImageUrl"
      @close="handleClose"
    />
  </div>
</template>

<script>
import utils from "./utils";
import notice from "../notice/notice.js";
export default {
  props: {
    //当前题目的所有相关信息
    previewOption: {
      type: Object,
    },
    //该题目在当前问卷中的序号
    index: {
      type: Number,
    },
    //该题目是否已做答，true为已答过，false为未答
    isAnswered: {
      type: Boolean,
    },
    //是否显示题目序号，true为显示，false为不显示
    isQuestionNum: {
      type: Boolean,
    },
  },
  created() {
    this.initData();
  },
  data() {
    return {
      isAnswer: false, //标志当前题目是否已做答
      isValided: false,
      answerVal: [],
      radioChecked: {}, //在类型为radio时保存选中的radio选项
      checkoxChecked: {}, //在类型为checkbox时保存选中的checkbox选项
      inputValue: {},
      MatrixQuestionOption: {},
      previewImageUrl: [],
      showPreview: false,
      MatrixQuestionOption1: {
        name: "请对喜欢的水果评价",
        rowType: ["不喜欢", "一般", "喜欢", "非常喜欢"],
        inputType: "row",
        columnType: [
          {
            id: utils.guid(),
            name: "苹果",
            value: "", //radio的value，值为rowType中的某个
            checkedValue: ["不喜欢", "喜欢"], //checkbox的value，值为rowType中的值
            rowType: [
              {
                name: "不喜欢",
                value: "hkjhj",
              },
              {
                name: "一般",
                value: "",
              },
              {
                name: "喜欢",
                value: "",
              },
              {
                name: "非常喜欢",
                value: "",
              },
            ],
          },
          {
            id: utils.guid(),
            name: "香蕉",
            value: "不喜欢",
            checkedValue: ["喜欢", "非常喜欢"],
            rowType: [
              {
                name: "不喜欢",
                value: "",
              },
              {
                name: "一般",
                value: "",
              },
              {
                name: "喜欢",
                value: "",
              },
              {
                name: "非常喜欢",
                value: "",
              },
            ],
          },
          {
            id: utils.guid(),
            name: "芒果",
            value: "",
            checkedValue: ["不喜欢", "喜欢"],
            rowType: [
              {
                name: "不喜欢",
                value: "",
              },
              {
                name: "一般",
                value: "",
              },
              {
                name: "喜欢",
                value: "",
              },
              {
                name: "非常喜欢",
                value: "",
              },
            ],
          },
        ],
        isMust: 1,
      },
    };
  },
  computed: {
    formattedQuestionName() {
      let htmlContent = this.MatrixQuestionOption.name || "";

      // 如果包含img标签，则设置图片大小为100px
      if (htmlContent.includes("<img")) {
        // 使用正则表达式匹配所有img标签并添加样式
        htmlContent = htmlContent.replace(/<img(.*?)>/g, (match, p1) => {
          // 检查是否已存在style属性
          if (p1.includes("style=")) {
            // 如果已存在style属性，在原有样式基础上添加width和height
            return match.replace(
              /style="(.*?)"/,
              'style="$1; width: 80px; height: 60px;"'
            );
          } else {
            // 如果不存在style属性，添加新的style属性
            return `<img${p1} style="width: 85px; height: 60px; margin:0px 5px">`;
          }
        });
      }

      return htmlContent;
    },
  },
  methods: {
    handleClose() {
      this.showPreview = false;
    },
    // 添加：处理HTML内容点击事件
    handleHtmlClick(event) {
      console.log(event, "wwwwwwwwwwwww");
      if (event.target.tagName === "IMG") {
        this.previewImageUrl = event.target.src.split(",");
        // this.imagePreviewVisible = true;
        this.showPreview = true;
      }
    },
    initData() {
      const columnOption = JSON.parse(this.previewOption.columnType);
      const rowOption = JSON.parse(this.previewOption.rowType);
      const columnType = columnOption.map((item) => {
        const row = rowOption.map((rowItem, index) => {
          //当矩阵类型是input时，判断是否有答题记录，有则将input的答案textValue保存
          if (
            this.previewOption.inputType === "number" ||
            this.previewOption.inputType === "row"
          ) {
            //判断当前问卷是否有答案列表
            let obj = { name: rowItem, value: "" };
            const answers = this.previewOption.answers;
            if (this.previewOption.answers.length > 0) {
              this.previewOption.answers.forEach((answerItem) => {
                if (
                  JSON.parse(answerItem.rowValue).id === rowItem.id &&
                  answerItem.columnValue === item
                ) {
                  obj = { name: rowItem.name, value: answerItem.textValue };
                }
              });
            }
            return obj;
          } else {
            //当矩阵类型是radio或checkbox时，则设置默认值
            return { name: rowItem, value: "" };
          }
        });
        const columnObj = this.previewOption.inputType === "radio" ? {} : [];
        if (this.previewOption.answers.length > 0) {
          this.previewOption.answers.forEach((answerItem) => {
            if (answerItem.columnValue === item) {
              this.previewOption.inputType === "radio"
                ? (columnObj[item] = JSON.parse(answerItem.rowValue).id)
                : columnObj.push(JSON.parse(answerItem.rowValue).id);
            }
          });
        }
        return {
          id: utils.guid(),
          name: item,
          // value: "",
          // checkedValue: [],
          value:
            this.previewOption.inputType === "radio" &&
            this.previewOption.answers.length > 0
              ? columnObj[item]
              : "", //保存radio的值
          checkedValue:
            this.previewOption.inputType === "checkbox" &&
            this.previewOption.answers.length > 0
              ? columnObj
              : [],
          rowType: row,
        };
      });
      this.MatrixQuestionOption = {
        ...this.previewOption,
        rowType: rowOption,
        columnType,
      };
      const MatrixQuestionOption = this.MatrixQuestionOption;
    },
    handleRadioChange(scope, column) {
      this.radioChecked[column.id] = {
        rowValue: scope.row,
        columnValue: column.name,
      };
      console.log("radioChecked", this.radioChecked);
      this.answerVal = [];
      for (const key in this.radioChecked) {
        if (this.radioChecked.hasOwnProperty(key)) {
          const radioElement = this.radioChecked[key];
          this.answerVal = this.answerVal.concat({
            pvqId: localStorage.getItem("currentQuestionId"), //问卷id
            questionId: this.MatrixQuestionOption.id, //题目id
            questionType: this.MatrixQuestionOption.type, //题目类型
            ...radioElement,
          });
        }
      }
      const radioCheckedArr = Object.keys(this.radioChecked);
      this.isAnswer =
        this.MatrixQuestionOption.columnType.length === radioCheckedArr.length;
      this.MatrixQuestionOption.isMust === 1 &&
        this.$parent.setAnswerPercentage(
          this.MatrixQuestionOption.id,
          this.isAnswer
        );
      this.isValided = false;
      //观察者触发
      notice.emitBrother("questionnaireObserver");
    },
    handleCheckboxChange(scope, column) {
      this.checkoxChecked[column.id] = column.checkedValue.map((item) => {
        const row = column.rowType.filter((element) => {
          return element.name.id === item;
        });
        return {
          rowValue: row[0].name,
          columnValue: column.name,
        };
      });
      this.answerVal = [];
      for (const key in this.checkoxChecked) {
        let checkboxValueItem = [];
        if (this.checkoxChecked.hasOwnProperty(key)) {
          const checkboxElement = this.checkoxChecked[key];
          checkboxValueItem = checkboxElement.map((item) => {
            return {
              pvqId: localStorage.getItem("currentQuestionId"), //问卷id
              questionId: this.MatrixQuestionOption.id, //题目id
              questionType: this.MatrixQuestionOption.type, //题目类型
              ...item,
            };
          });
        }
        this.answerVal = this.answerVal.concat(checkboxValueItem);
      }
      //保存多选时有效值（将选中再取消时，对象里的空值过滤掉）
      let checkedRow = {};
      for (const key in this.checkoxChecked) {
        if (this.checkoxChecked.hasOwnProperty(key)) {
          const item = this.checkoxChecked[key];
          if (item.length !== 0) {
            checkedRow[key] = item;
          }
        }
      }
      const checkoxCheckedArr = Object.keys(checkedRow);
      this.isAnswer =
        this.MatrixQuestionOption.columnType.length ===
        checkoxCheckedArr.length;
      this.MatrixQuestionOption.isMust === 1 &&
        this.$parent.setAnswerPercentage(
          this.MatrixQuestionOption.id,
          this.isAnswer
        );
      this.isValided = false;
      //观察者触发
      notice.emitBrother("questionnaireObserver");
    },
    handleInputChange(column, rowIndex) {
      const rowItems = column.rowType.filter((rowItem) => {
        return rowItem.value;
      });
      this.inputValue[column.id] = rowItems.map((rowItem) => {
        return {
          rowValue: rowItem.name,
          columnValue: column.name,
          textValue: rowItem.value,
        };
      });
      this.answerVal = [];
      for (const key in this.inputValue) {
        let inpputValueItem = [];
        if (this.inputValue.hasOwnProperty(key)) {
          const inutElement = this.inputValue[key];
          inpputValueItem = inutElement.map((item) => {
            return {
              pvqId: localStorage.getItem("currentQuestionId"), //问卷id
              questionId: this.MatrixQuestionOption.id, //题目id
              questionType: this.MatrixQuestionOption.type, //题目类型
              ...item,
            };
          });
        }
        this.answerVal = this.answerVal.concat(inpputValueItem);
      }
      let inputValueLength = 0; //矩阵中所有input的个数
      for (const key in this.inputValue) {
        if (this.inputValue.hasOwnProperty(key)) {
          const element = this.inputValue[key];
          inputValueLength += element.length;
        }
      }
      //当矩阵红input的个数等于行和列的乘积，即所有input框都有输入值，则标志位该题目已答
      this.isAnswer =
        inputValueLength ===
        this.MatrixQuestionOption.columnType.length *
          this.MatrixQuestionOption.rowType.length
          ? true
          : false;
      this.MatrixQuestionOption.isMust === 1 &&
        this.$parent.setAnswerPercentage(
          this.MatrixQuestionOption.id,
          this.isAnswer
        );
      this.isValided = false;
      //观察者触发
      notice.emitBrother("questionnaireObserver");
    },
    checkValided() {
      if (this.MatrixQuestionOption.isMust === 0) {
        return false;
      }
      //判断当前题目是否必填，必填时才需要判断是否已答
      if (this.MatrixQuestionOption.isMust !== 1) {
        return true;
      }
      //判断当前题目是否已答
      if (!this.isAnswer) {
        return true;
      }
      //当矩阵题目类型为文本或者数字时，判断矩阵中的输入框每项是否均已填写
      if (
        this.MatrixQuestionOption.inputType === "row" ||
        this.MatrixQuestionOption.inputType === "number"
      ) {
        let inputValueLength = 0;
        for (const key in this.inputValue) {
          if (this.inputValue.hasOwnProperty(key)) {
            const element = this.inputValue[key];
            inputValueLength += element.length;
          }
        }
        if (
          inputValueLength <
          this.MatrixQuestionOption.columnType.length *
            this.MatrixQuestionOption.rowType.length
        ) {
          return true;
        }
      }
      if (this.MatrixQuestionOption.inputType === "number") {
        let validResult = false;
        for (const key in this.inputValue) {
          if (!validResult && this.inputValue.hasOwnProperty(key)) {
            const element = this.inputValue[key];
            for (let index = 0; index < element.length; index++) {
              const item = element[index];
              if (
                parseInt(item.textValue) < this.MatrixQuestionOption.minValue ||
                parseInt(item.textValue) > this.MatrixQuestionOption.maxValue
              ) {
                validResult = true;
                break;
              }
            }
          }
        }
        return validResult;
      }
      //当矩阵题目类型为单选类型时，判断矩阵中每列数据是否有选中（以列为分组）
      if (
        this.MatrixQuestionOption.inputType === "radio" &&
        Object.keys(this.radioChecked).length <
          this.MatrixQuestionOption.columnType.length
      ) {
        return true;
      }
      //当矩阵题目类型为多选类型时，判断矩阵中每列数据是否有选中（以列为分组）
      if (
        this.MatrixQuestionOption.inputType === "checkbox" &&
        Object.keys(this.checkoxChecked).length <
          this.MatrixQuestionOption.columnType.length
      ) {
        return true;
      }
      return false;
    },
    doValidedFlag() {
      return this.checkValided();
    },
    doValided() {
      this.isValided = this.checkValided();
      return this.isValided;
    },
  },
};
</script>

<style lang="stylus" type="stylesheet/stylus">
.matrix-container {
  padding: 10px;

  .quesName {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 4px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .question-name-text {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #353535;
  }

  .starRed {
    color: red;
    font-weight: 600;
  }

  .chexMinMax {
    color: blue;
    font-size: 14px;
    margin-left: 3px;
  }

  .questionContainer {
    padding: 20px 0px 20px 0px;

    .el-radio__input.is-checked .el-radio__inner {
      border-color: #2cc7c5;
      background: #2cc7c5;
    }

    // radio在disable时的样式
    .el-radio__input.is-disabled .el-radio__inner, .el-radio__input.is-disabled.is-checked .el-radio__inner {
      border-color: #f5f7fa;
      background: #f5f7fa;
    }

    .el-radio__input.is-checked+.el-radio__label {
      color: #2cc7c5;
    }

    .el-input__inner:focus {
      border: 1px solid #2CC7C5;
      outline: none;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #2cc7c5;
      border-color: #2cc7c5;
    }

    // chebox在disable时的样式
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
      border-color: #f5f7fa;
      background: #f5f7fa;
    }

    .cell {
      width: 100px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .common-container {
    border: 1px solid transparent;
    padding: 9px;
  }

  .error-border {
    border: 1px solid red;
    padding: 9px;
  }

  div >>> .el-input__inner {
    padding: 0 0 0 10px;
  }

  .el-table th>.cell, .el-table .cell {
    white-space: nowrap;
  }
}
</style>